import { Helmet } from "react-helmet-async"
import { useLocation, useParams } from "react-router-dom"

import { canonicalUrl, resolveSeo } from "@/lib/seo"

export function RouteSeo() {
  const { pathname } = useLocation()
  const { slug } = useParams<{ slug?: string }>()
  const { title, description, ogImage } = resolveSeo(pathname, slug)
  const canonical = canonicalUrl(pathname)

  return (
    <Helmet htmlAttributes={{ lang: "en" }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  )
}
